import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import Styleguide from "@toolkit/Framework/Types/Styleguide";

const link: Styleguide["tag"] = {
    gap: pxToRem(10),
};

export default link;
